module.exports = __webpack_public_path__ + "img/blob_1.32777234.svg";